import { render } from "./CoursesTermsConditionModal.vue?vue&type=template&id=50794ff0&ts=true"
import script from "./CoursesTermsConditionModal.vue?vue&type=script&lang=ts"
export * from "./CoursesTermsConditionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__